import { routePaths } from '../../../routePaths';
import { translate } from '../../../utils';
import { RouteType } from '../../../types';
import { WarehousePermission } from '../../../generated/graphql';
import { DeductionListDetails } from '../../../modules';
import DeductionLists from './DeductionLists';

const WarehouseDeductionListsRoute: RouteType = {
    exact: false,
    showInSideBar: true,
    path: routePaths.warehouseDeductionLists,
    title: translate('Write-offs'),
    permissions: {
        warehouse: [WarehousePermission.CanViewDeductionList],
    },
    component: DeductionLists,
    childrenRoutes: [
        {
            exact: true,
            path: routePaths.warehouseDeductionListsDetails,
            component: DeductionListDetails,
            title: translate('Deduction list'),
            permissions: {
                warehouse: [WarehousePermission.CanViewDeductionList]
            },
            redirectRoute: routePaths.warehouseDeductionLists,
        }
    ],
};

export default WarehouseDeductionListsRoute;
